/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class OverrideSensitivityAnnotationsRequest {
  /**
  * Whether the resource should be marked as having sensitivity annotations.
  */
  'hasSensitivityAnnotations': boolean;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "hasSensitivityAnnotations",
      "baseName": "hasSensitivityAnnotations",
      "type": "boolean",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return OverrideSensitivityAnnotationsRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

